const colors = {
    ADMIN: '#ff8989',
    TEAM_LEADER: '#ffbd5b'
};

export default role => !!colors[role] ? colors[role] : undefined;